import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/consignment/page',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/consignment/saveOrUpdate',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/consignment/detail/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/consignment/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/consignment/' + id,
method: 'put',
data: obj
})
}
